import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import env from '../environment';
import moment from 'moment';
import roles from '../utils/roles';
import * as user from '../utils/entityUtils';
import { Button, Modal } from 'react-bootstrap';
import _ from 'lodash';

import AutoAttributeInput from './AutoAttributeInput';
import AutoCustomerInput from './AutoCustomerInput';
import AutoUserInput from './AutoUserInput';
import CalendarWidget from './CalendarWidget';
import ColorPicker from './ColorPicker';
import DatePicker from 'react-datepicker';
import ProjectNameModal from './ProjectNameModal';
import CustomerGroupProjectWidget from './CustomerGroupProjectWidget';

import * as events from '../constants/eventActions';
import attributeActions from '../actions/attributeActionCreators';
import customerActions from '../actions/customerActionCreators';
import customerGroupActions from '../actions/customerGroupActionCreators';
import projectActions from '../actions/projectActionCreators';

require.ensure([], () => {
    require('./PMOProjectListWidget.less');
    require('./DatePicker.less');
});

let taggyImage = require('../../img/taggy.png');

const projectSizeResolver = {
  "SMALL": "Mali",
  "MEDIUM": "Srednji",
  "LARGE": "Veliki"
};

const projectServiceTypeResolver = {
  "DEVELOPMENT": "Razvoj",
  "MAINTENANCE": "Održavanje",
  "IMPLEMENTATION": "Implementacija",
  "CONSULTING": "Konzalting",
  "PROJECT_MANAGEMENT": "Upravljanje projektima",
  "LICENSES": "Licenciranje",
  "HARDWARE": "Hardware"
};

class EditAttributesWidget extends React.Component {

    constructor(props, context) {
        super(props, context);
        let bannedUserIDs = [];

        if (this.props.project.manager) {
            bannedUserIDs[2] = this.props.project.manager.id;
        }
        if (this.props.project.coManager1) {
            bannedUserIDs[0] = this.props.project.coManager1.id;
        }
        if (this.props.project.coManager2) {
            bannedUserIDs[1] = this.props.project.coManager2.id;
        }

        let setAttributes = this.props.project.attributes ? this.props.project.attributes : [];
        let defaultAttributes = this.props.defaultAttributes;
        let setIDs = setAttributes.map(e => e.attribute.id);
        let defIDs = defaultAttributes.map(e => e.id);
        let toAdd = [];
        defIDs.map(e => {
            if(setIDs.indexOf(e) === -1) {
                toAdd.push(e);
            }
        }
        );
        for(let i = 0; i < defaultAttributes.length; i++) {
            if(toAdd.includes(defaultAttributes[i].id)) {
                let setAttribute = {
                    attribute: defaultAttributes[i],
                    key: defaultAttributes[i].type,
                    value: defaultAttributes[i].defaultValue
                }
                setAttributes.push(setAttribute);
            }
        }
        setAttributes = _.orderBy(setAttributes, function(e) {return e.attribute.description});
        let attributes = [...setAttributes];
        let attributeValues = [];
        let attributesChanged = [];
        let attributesPreset = [];

        for (let i = 0; i < setAttributes.length; ++i) {
            for (let j = 0; j < attributes.length; ++j) {
                let attribute = attributes[j].attribute;
                attribute.key = attributes[j].key;
                attribute.value = attributes[j].value;

                if (attribute.name === setAttributes[i].key) {
                    if (attribute.type.toUpperCase() === "BOOL") {
                        attributeValues[j] = setAttributes[i].value === "TRUE" ? true : setAttributes[i].value;
                    } else {
                        attributeValues[j] = setAttributes[i].value;
                    }

                    attributesChanged[j] = false;
                    attributesPreset[j] = true;
                    break;
                }
            }
        }

        //if the user is only PM, he cannot edit the project manager of the project
        let readOnly = false;
        if (this.props.currentUser.roles.includes("PM") && !this.props.currentUser.roles.includes("PMO")) {
            readOnly = true;
        }

        //if the user is not a PM, he cannot submit any changes to the project details
        let readOnlyPM = readOnly;
        if (this.props.project.manager.id === this.props.currentUser.id)
                readOnlyPM = false;

              if (this.props.project.coManager1 && this.props.project.coManager1.id === this.props.currentUser.id)
                  readOnlyPM = false;
              if (this.props.project.coManager2 && this.props.project.coManager2.id === this.props.currentUser.id)
                  readOnlyPM = false;

        for (let i = 0; i < attributes.length; ++i) {
            let attribute = attributes[i];
            if (!attributeValues[i] && attribute.required)  {
                if (attribute.type.toUpperCase() === "STRING") {
                    attributeValues[i] = attribute.defaultValue;
                }
                if (attribute.defaultValue) {
                    attributesChanged[i] = true;
                    attributesPreset[i] = true;
                }
            }
        }

        let approvers = this._findApproversFromProps(this.props);
        approvers.push({"givenName":"Line", "id": null, "active": true, "surname": "Manager", "username": "linemanager"});

        this.state = {
            approver: this.props.project.approver ? this.props.project.approver : {"givenName":"Line", "id": null, "active": true, "surname": "Manager", "username": "linemanager"},
            approvers: approvers,
            archived: this.props.project.archived,
            attributes: attributes,
            attributeValues: attributeValues,
            attributesChanged: attributesChanged,
            attributesPreset: attributesPreset,
            bannedUserIDs: bannedUserIDs,
            customer: this.props.project.customer,
            coManager1: this.props.project.coManager1,
            coManager2: this.props.project.coManager2,
            contract: this.props.project.contract,
            contractor: this.props.project.contractor,
            createdAt: this.props.project.createdAt ? moment(this.props.project.createdAt) : undefined,
            defaultColor: this.props.project.defaultColor,
            description: this.props.project.description,
            descriptionEng: this.props.project.descriptionEng,
            endDate: this.props.project.endDate ? moment(this.props.project.endDate) : undefined,
            initialName: this.props.project.name,
            manager: this.props.project.manager,
            name: this.props.project.name,
            size: this.props.project.size,
            serviceTypes: this.props.project.serviceTypes,
            noChanges: true,
            newlyAssigned: [],
            productive: this.props.project.productive,
            showOnTaggy: this.props.project.showOnTaggy,
            projectNameCv: this.props.project.projectNameCv,
            projectNameCvEng: this.props.project.projectNameCvEng,
            readOnly: readOnly,
            readOnlyPM: readOnlyPM,
            setAttributes: setAttributes,
            sponsor: this.props.project.sponsor,
            sponsorUsers: this.props.sponsorUsers,
            startDate: this.props.project.startDate ? moment(this.props.project.startDate) : undefined,
            inactiveDate: this.props.project.inactiveDate ? moment(this.props.project.inactiveDate) : undefined,
            toRemove: [],
        };
    }

    // LIFECYCLE METHODS

    componentWillMount = () => {
        this.props.dispatch(projectActions.isDeletable(this.props.project.id));
    };

    // EVENT HANDLERS

    closeModal = () => {
        this.setState({
            showModal: false
        });
    };

    handleAddCustomerGroupProject = (customerGroupProject) => {
        let newlyAssigned = this.state.newlyAssigned;
        newlyAssigned.push(customerGroupProject);

        this.setState({
            newlyAssigned,
            noChanges: false
        });
    };

    handleApproverClick = (payload) => {
        this.setState({
            approver: payload,
            noChanges: false
        }, this.validate);
    };

    handleApproverTextChange = (refName, event) => {
        this.setState({
            approver: null,
            noChanges: false
        });
    };

    handleArchive = () => {
        this.props.handleArchiveProject(this.props.project);
    };


    handleCheckboxChange = (attributeKey) => {
        if (this.state.attributeValues[attributeKey] === 'false') {
            this.state.attributeValues[attributeKey] = true;
        } else {
            this.state.attributeValues[attributeKey] = !this.state.attributeValues[attributeKey];
        }
        this.state.attributesChanged[attributeKey] = true;
        this.forceUpdate();
    };

    handleColorChange = (color) => {
        this.setState({
            defaultColor: color,
            noChanges: false
        });
    };

    handleComboSelect = (attributeKey, codeValue) => {
        this.state.attributeValues[attributeKey] = codeValue.code;
        this.state.attributesChanged[attributeKey] = true;
        this.forceUpdate();
    };

    handleCompanyChange = () => {
        this.setState({
            customer: null,
            noChanges: false
        });
    };

    handleCompanyClick = (payload) => {
        this.setState({
            customer: payload,
            noChanges: false
        });
    };

    handleConfirmedDelete = () => {
        this.props.handleDeleteProject(this.props.project.id);
        this.hideModalDialog();
    };

    handleContractorChange = (event) => {
        this.setState({
            contractor: event.target.value,
            noChanges: false
        });
    };

    handleContractorClick = (payload) => {
      this.setState({
        contractor: payload,
        noChanges: false
      });
    };

    handleCoPm1Click = (payload) => {
        let approvers = [];
        approvers.push(payload);
        approvers.push(this.state.manager);
        //co-PM 1
        if (this.state.coManager2) {
            approvers.push(this.state.coManager2);
        }

        approvers.push({"givenName":"Line", "id": null, "active": true, "surname": "Manager", "username": "linemanager"});

        this.setState({
            approvers: approvers,
            coManager1: payload.id === null ? null : payload,
            noChanges: false
        });
        this.state.bannedUserIDs[0] = payload.id === null ? null : payload.id;
    };

    handleCoPm1TextChange = () => {
        this.setState({
            coManager1: null,
            noChanges: false
        });

        let payload = {
          id : null,
          noChanges: false
        };

        this.handleCoPm1Click(payload);
    };

    handleCoPm2Click = (payload) => {
        let approvers = [];
        approvers.push(payload);
        approvers.push(this.state.manager);
        //co-PM 1
        if (this.state.coManager1) {
            approvers.push(this.state.coManager1);
        }

        approvers.push({"givenName":"Line", "id": null, "active": true, "surname": "Manager", "username": "linemanager"});

        this.setState({
            approvers: approvers,
            coManager2: payload.id === null ? null : payload,
            noChanges: false
        });
        this.state.bannedUserIDs[1] = payload.id === null ? null : payload.id;
    };

    handleCoPm2TextChange = () => {
        this.setState({
            coManager2: null,
            noChanges: false
        });

        let payload = {
          id : null,
          noChanges: false
        };

        this.handleCoPm2Click(payload);
    };

    handleDateChange = (attributeKey, value) => {
        this.state.attributeValues[attributeKey] = value.format("YYYY-MM-DD");
        this.state.attributesChanged[attributeKey] = true;
        this.forceUpdate();
    };

    handleDeleteProject = () => {
        this.setState({
            showDeleteModal: true
        });
    };

    handleDescriptionChange = (event) => {
        this.setState({
            description: event.target.value,
            noChanges: false
        });
    };

    handleDescriptionEngChange = (event) => {
        this.setState({
            descriptionEng: event.target.value,
            noChanges: false
        });
    };

    handleEndDateChange = (date) => {
        this.setState({
            endDate: !date ? null : moment(date, "YYYY-MM-DD"),
            noChanges: false
        },
        this.validate);
    };

    handleNameChange = (event) => {
        let name = event.target.value.trim();

        this.setState({
            name: event.target.value,
            nameError: name === '' || this._projectExists(name) !== -1,
            noChanges: false
        });
    };

    handleProjectNameCvChange = (event) => {
        let projectNameCv = event.target.value.trim();
        this.setState({
            projectNameCv: projectNameCv,
            noChanges: false
        });
    };

    handleProjectNameCvEngChange = (event) => {
        this.setState({
            projectNameCvEng: event.target.value,
            noChanges: false
        });
    };

    handlePmClick = (payload) => {
        let approvers = [];
        approvers.push(payload);
        //co-PM 1
        if (this.state.coManager1) {
            approvers.push(this.state.coManager1);
        }
        //co-PM 2
        if (this.state.coManager2) {
            approvers.push(this.state.coManager2);
        }
        approvers.push({"givenName":"Line", "id": null, "active": true, "surname": "Manager", "username": "linemanager"});

        this.setState({
            approvers: approvers,
            manager: payload,
            noChanges: false
        });
        this.state.bannedUserIDs[2] = payload.id;
    };

    handlePmTextChange = () => {
        let payload = {
            id : null,
            noChanges: false
        };

        this.handlePmClick(payload);
    };

    handleProductiveChange = (event) => {
        this.setState({
            productive: !this.state.productive,
            noChanges: false
        });
    };
    
    handleShowOnTaggyChange = (event) => {
        this.setState({
            showOnTaggy: !this.state.showOnTaggy,
            noChanges: false
        });
    };

    handleRemoveExisting = (customerGroupProject) => {
        let toRemove = this.state.toRemove;
        toRemove.push(customerGroupProject);
        this.setState({
            toRemove,
            noChanges: false
        });
    };

    handleRemoveNewlyAssigned = (customerGroupProject) => {
        let newlyAssigned = this.state.newlyAssigned;
        let index = newlyAssigned.indexOf(customerGroupProject);

        newlyAssigned.splice(index, 1);
        this.setState({
            newlyAssigned,
            noChanges: false
        });
    };

    handleSave = () => {
        let noChanges = this.state.noChanges;
        for (let i = 0; i < this.state.attributesChanged.length; i++) {
            if (this.state.attributesChanged[i]) {
                noChanges = false;
                break;
            }
        }

        if (noChanges) return;

        let project = {
            name: this.state.name,
            description: this.state.description,
            descriptionEng: this.state.descriptionEng,
            archived: this.state.archived,
            approver: this.state.approver ? this.state.approver : null,
            coManager1: this.state.coManager1,
            coManager2: this.state.coManager2,
            createdAt: this.state.createdAt ? this.state.createdAt.format("YYYY-MM-DD") : null,
            defaultColor: this.state.defaultColor,
            id: this.props.project.id,
            manager: this.state.manager ? this.state.manager : null,
            sponsor: this.state.sponsor ? this.state.sponsor : null,
            startDate: this.state.startDate ? this.state.startDate.format("YYYY-MM-DD") : null,
            endDate: this.state.endDate ? this.state.endDate.format("YYYY-MM-DD") : null,
            inactiveDate: this.state.inactiveDate ? this.state.inactiveDate.format("YYYY-MM-DD") : null,
            attributes: this.state.attributes,
            contractor: this.state.contractor,
            contract: this.state.contract,
            customer: this.state.customer ? this.state.customer : null,
            productive: this.state.productive,
            showOnTaggy: this.state.showOnTaggy,
            projectNameCv: this.state.projectNameCv,
            projectNameCvEng: this.state.projectNameCvEng,
            type: this.props.project.type
        };

        if (!this.validate()) {
            return;
        }

        if (project.endDate === "Invalid date") {
            project.endDate = null;
        }

        let attributeValues = [];
        for (let i in this.state.attributes) {
            if (!this.state.attributeValues[i] && this.state.attributesChanged[i] && this.state.attributes[i].attribute.type === "CODE") {
                let attributeValue = {
                    attribute: this.state.attributes[i].attribute,
                    value: null,
                    key: this.state.attributes[i].key
                };

                attributeValues.push(attributeValue);
                continue;
            }

            if (!this.state.attributeValues[i] && !this.state.attributes[i].attribute.type === "BOOL") {
                continue;
            }
            if (!this.state.attributesChanged[i])  {
                continue;
            }
            let attributeValue = {
                attribute: this.state.attributes[i].attribute,
                value: this.state.attributeValues[i].toString(),
                key: this.state.attributes[i].attribute.name
            };
            attributeValues.push(attributeValue);
        }
        this.props.dispatch(projectActions.checkProjectNameCV(project));

        //TODO: Do not use setTimeout
        setTimeout(() => {
            this._handleCheckProjectNameCV(attributeValues, project);
        }, 1000);
    };

    _handleCheckProjectNameCV(attributeValues, project) {

        if (this.props.sameProjects) {
            if (this.props.sameProjects.length > 0) {
                let modal = <ProjectNameModal
                            attributeValues={attributeValues}
                            handleClose={this.closeModal}
                            handleConfirm={this._updateProject}
                            key={project.id}
                            projects={this.props.sameProjects}
                            project={project}
                            />;
                this.setState({
                    modal: modal,
                    showModal: true
                });
            } else {
                this._updateProject(attributeValues, project);
            }
        } else {
            this.props.dispatch(events.pushErrorEvent({ data: "check project name CV of project" }));
        }
    }

    handleSponsorClick = (payload) => {
        this.setState({
            sponsor: payload,
            noChanges: false
        });
    };

    handleSponsorTextChange = () => {
        this.setState({
            sponsor: null,
            noChanges: false
        });
    };

    handleStartDateChange = (date) => {
        this.setState({
            startDate: !date ? null : moment(date, "YYYY-MM-DD"),
            noChanges: false
        },
        this.validate);
    };

    handleSyncCustomers = () => {
        this.props.dispatch(customerActions.sync());
    };

    handleTextChange = (attributeKey, event) => {
        this.state.attributeValues[attributeKey] = event.target.value;
        this.state.attributesChanged[attributeKey] = true;
        this.forceUpdate();
    };

    handleLinkToTaggy = () => {
        window.open(env.taggy /*+ '/#/tashiProject/' + this.props.project.id*/);
    };

    handleUnarchive = () => {
        this.props.handleUnarchiveProject(this.props.project);
    };

    // OTHER METHODS

    //function used for finding approvers. A project approver can only be the manager of the
    //project or one of the co-managers.
    _findApproversFromProps = (props) => {
        let approvers = [];
        approvers.push(props.project.manager);
        if (props.project.coManager1) {
            approvers.push(props.project.coManager1);
        }
        if (props.project.coManager2) {
            approvers.push(props.project.coManager2);
        }

        return approvers;
    };

    _projectExists = (name) => {
        let searchElement = name.toLowerCase();

        let minIndex = 0;
        let maxIndex = this.props.projectNames.length - 1;
        let currentIndex;
        let currentElement;

        while (minIndex <= maxIndex) {
            currentIndex = (minIndex + maxIndex) / 2 | 0;
            currentElement = this.props.projectNames[currentIndex];

            if (currentElement < searchElement) {
                minIndex = currentIndex + 1;
            } else if (currentElement > searchElement) {
                maxIndex = currentIndex -1;
            } else {
                if (this.props.project.name.toLowerCase() === this.props.projectNames[currentIndex]) {
                    return -1;
                }
                return currentElement;
            }
        }

        return -1;
    };

    _updateProject = (attributeValues, project) => {
        this.props.dispatch(attributeActions.setValues(this.props.project.id, attributeValues));
        this.state.attributesChanged = [];

        let newlyAssigned = this.state.newlyAssigned;
        if(newlyAssigned.length > 0) {
            for(let i = 0; i < newlyAssigned.length; i++)
                this.props.dispatch(customerGroupActions.create(newlyAssigned[i]));
        }

        let toRemove = this.state.toRemove;
        if(toRemove.length > 0) {
            for(let i = 0; i < toRemove.length; i++)
                this.props.dispatch(customerGroupActions.delete(toRemove[i]));
        }

        this.setState({
            newlyAssigned: [],
            toRemove: []
        });

        this.props.handleSave(project);
        this.state.initialName = this.state.name;
    };

    hideModalDialog = () => {
        this.setState({
            showDeleteModal: false
        });
    };

    parseServiceTypes = (serviceTypes) => {
      let resultString = "";
      for (const idx in serviceTypes) {
        resultString += projectServiceTypeResolver[serviceTypes[idx]] + ", ";
      }

      return resultString.substring(0, resultString.length - 2);
    }

    renderAttributeField = (attribute, attributeKey) => {
        let valueField = null;

        //TODO fix object construction to avoid having to do it manually
        let attributeObject = attribute.attribute;
        attributeObject.key = attribute.key;
        attributeObject.value = attribute.value;

        switch(attributeObject.type.toUpperCase()) {

            case "STRING":
                valueField =
                    <input disabled type="text" className="form-control" onChange={this.handleTextChange.bind(this, attributeKey)} value={this.state.attributeValues[attributeKey]}/>;
                break;
            case "BOOL":
                let checked;
                if (this.state.attributeValues[attributeKey] === false || (typeof this.state.attributeValues[attributeKey] === 'string' && this.state.attributeValues[attributeKey].toLowerCase() === 'false')) {
                    checked = false;
                }
                if (this.state.attributeValues[attributeKey] === true || (typeof this.state.attributeValues[attributeKey] === 'string' && this.state.attributeValues[attributeKey].toLowerCase() === 'true')) {
                    checked = true;
                }

                valueField =
                    <label>
                        <input disabled type="checkbox" onChange={this.handleCheckboxChange.bind(this, attributeKey)} checked={checked}/>
                        &nbsp;{attributeObject.description}
                    </label>;
                break;
            case "DATE":
                valueField =
                    <CalendarWidget
                        setDate={this.handleDateChange.bind(this, attributeKey)}
                        date={moment(this.state.attributeValues[attributeKey], "YYYY-MM-DD")}
                        key={attributeKey}
                        id={attributeKey}
                        pullLeft
                        />;
                break;
            case "CODE":
                let defaultText = "";

                for (let i = 0; i < attributeObject.values.length; i++) {
                    if (this.state.attributeValues[attributeKey] === attributeObject.values[i].code) {
                            defaultText = attributeObject.values[i].value;
                            break;
                    }
                }

                valueField =
                    <AutoAttributeInput
                        codeValues={attributeObject.values}
                        handleFunction={this.handleComboSelect}
                        attributeID={attributeKey}
                        keepAfterClick
                        placeholder={attributeObject.description}
                        defaultText={defaultText}
                        enableClear
                        readOnly={attributeObject.description !== 'Drzava'}
                        />;
                break;
        }

        if (attribute.attribute.name != 'PROJECT_COUNTRY') {
          return <div></div>
        }

        return (
            <div className="form-group" key={attributeKey} id={attributeKey}>
                <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">{attributeObject.type.toUpperCase() === "BOOL" ? "" : attributeObject.description + ":"} </label>
                <div className="col-lg-6 col-md-7 col-sm-7">
                    {valueField}
                </div>
            </div>
        );
    };

    setActiveTab = (index) => {
        this.props.setActiveTab(index);
    };

    setDefaultAttributeValues = () => {
        for (let i = 0; i < this.state.setAttributes.length; ++i) {
            for (let j = 0; j < this.state.attributes.length; ++j) {
                let attribute = this.state.attributes[j];
                if (attribute.name === this.state.setAttributes[i].key) {
                    if (attribute.type.toUpperCase() === "BOOL") {
                        this.state.attributeValues[j] = this.state.setAttributes[i].value === "TRUE" ? true : this.state.setAttributes[i].value;
                    } else {
                        this.state.attributeValues[j] = this.state.setAttributes[i].value;
                    }

                    this.state.attributesChanged[j] = false;
                    this.state.attributesPreset[j] = true;
                    break;
                }
            }
        }

        for (let i = 0; i < this.state.attributes.length; ++i) {
            let attribute = this.state.attributes[i].attribute;
            if (!this.state.attributeValues[i] && attribute.required)  {
                this.state.attributeValues[i] = attribute.defaultValue;
                if (attribute.defaultValue) {
                    this.state.attributesChanged[i] = true;
                    this.state.attributesPreset[i] = true;
                }
            }
        }

        this.forceUpdate();
    };

    validate = () => {
        let now = moment();

        let startDateError = false;
        if (!this.state.startDate || this.state.startDate.format("YYYY-MM-DD") === "Invalid date" || this.state.startDate.format("YYYY-MM-DD") < moment(this.state.createdAt, "YYYY-MM-DD").subtract(6, 'months').format("YYYY-MM-DD")) {
            startDateError = true;
        }

        let endDateError = false;
        if (this.state.endDate && !startDateError && this.state.endDate.format("YYYY-MM-DD") !== "Invalid date") {
            endDateError = this.state.endDate.format("YYYY-MM-DD") > now.add(5, 'years').format("YYYY-MM-DD") || this.state.endDate.format("YYYY-MM-DD") <= this.state.startDate.format("YYYY-MM-DD");
        }

        let approverError = true;

        if(this.state.approver) {
            for(let i = 0; i < this.state.approvers.length; i++) {
                if(this.state.approvers[i].id === this.state.approver.id)
                    approverError = false;
            }
        }

        let sponsorError = true;

        if(this.state.sponsor) {
            for(let i = 0; i < this.state.sponsorUsers.length; i++) {
                if(this.state.sponsorUsers[i].id === this.state.sponsor.id)
                    sponsorError = false;
            }
        }

        let managerError = this.state.manager.id === null;
        let nameError = this.state.name.trim() === '' || this._projectExists(this.state.name) !== -1;

        this.setState({
            nameError: nameError,
            managerError: managerError,
            startDateError: startDateError,
            endDateError: endDateError,
            approverError: approverError,
            sponsorError: sponsorError
        });

        this.forceUpdate();
        return (!nameError && !managerError && !startDateError && !endDateError && !approverError && !sponsorError); // De Morgan da nam undefined bude truthy
    };

    // RENDER METHOD

    render = () => {
        let modal = (
            <Modal show={true} title={"Confirm project deletion"}>
                <div className="modal-body">
                    Are you sure you want to delete project {this.props.project ? this.props.project.name : ""}?
                </div>
                <div className="modal-footer">
                    <Button onClick={this.handleConfirmedDelete}>Yes</Button>
                    <Button onClick={this.hideModalDialog}>No</Button>
                </div>
            </Modal>
        );

        return (
            <div className="main">
                { this.state.showDeleteModal ? modal : null }
                { this.state.showModal ? this.state.modal : null }
                <div>
                    <div className="row project">
                        <div className="col-lg-10 col-lg-offset-1 col-md-12">
                            <div role="tabpanel">
                                <ul className="nav nav-tabs">
                                    <li title="Tasks on project" role="presentation" >
                                        <a style={{"cursor" : "pointer"}} onClick={this.setActiveTab.bind(this, 0)} aria-controls="project-tasks" role="tab" data-toggle="tab">
                                            Project Tasks
                                        </a>
                                    </li>
                                    <li title="Project settings and attributes" role="presentation" className="active">
                                        <a style={{"cursor" : "pointer"}} onClick={this.setActiveTab.bind(this, 1)} aria-controls="project-details" role="tab" data-toggle="tab">
                                            Project Details
                                        </a>
                                    </li>
                                </ul>
                                <div className="tab-content">
                                    <div role="tabpanel" style={{paddingTop : "20px"}} id="project-details">
                                        <form className="form-horizontal">
                                        <div className={this.state.nameError ? "form-group has-error" : "form-group"}>
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Project Name:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <input disabled value={this.state.name} onChange={this.handleNameChange} type="text" className="form-control" id="project_name"/>
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Project Description:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <textarea disabled className="no-horizontal-resize form-control" maxLength="1024" defaultValue={this.state.description} onChange={this.handleDescriptionChange} id="project_description"/>
                                            </div>
                                            <img src={taggyImage} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Project Description (eng):</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <textarea disabled className="no-horizontal-resize form-control" maxLength="1024" defaultValue={this.state.descriptionEng} onChange={this.handleDescriptionEngChange} id="project_description_eng"/>
                                            </div>
                                            <img src={taggyImage} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Project Color:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <ColorPicker
                                                    defaultColor={this.state.defaultColor}
                                                    handleColorChange={this.handleColorChange}
                                                    />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Created Date:</label>
                                            <div className="col-lg-2 col-md-5 col-sm-5">
                                                <input value={this.state.createdAt ? this.state.createdAt.format('YYYY-MM-DD') : ''} readOnly={true} type="text" className="form-control"/>
                                            </div>
                                        </div>
                                        <div className={this.state.startDateError ? "form-group has-error" : "form-group"}>
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Start Date:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <DatePicker
                                                    dateFormat="YYYY-MM-DD"
                                                    onChange={this.handleStartDateChange}
                                                    placeholderText="Start date"
                                                    selected={this.state.startDate}
                                                    showYearDropdown
                                                    disabled
                                                    />
                                            </div>
                                        </div>
                                        <div className={this.state.endDateError ? "form-group has-error" : "form-group"}>
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">End Date:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <DatePicker
                                                    dateFormat="YYYY-MM-DD"
                                                    onChange={this.handleEndDateChange}
                                                    placeholderText="End date"
                                                    selected={this.state.endDate}
                                                    showYearDropdown
                                                    disabled
                                                    />
                                            </div>
                                        </div>
                                          { this.state.inactiveDate &&
                                            <div className={"form-group"}>
                                              <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Inactive date:</label>
                                              <div className="col-lg-6 col-md-7 col-sm-7">
                                                <DatePicker
                                                  dateFormat="YYYY-MM-DD"
                                                  placeholderText="Inactive date"
                                                  selected={this.state.inactiveDate}
                                                  showYearDropdown
                                                  disabled
                                                />
                                              </div>
                                            </div>
                                          }
                                        <div className={this.state.managerError ? "form-group has-error" : "form-group"}>
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Project Manager:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <AutoUserInput
                                                    bannedUserIDs={this.state.bannedUserIDs}
                                                    forceInitialPopup={false}
                                                    handleFunction={this.handlePmClick}
                                                    handleTextChange={this.handlePmTextChange}
                                                    keepAfterClick
                                                    readOnly={true}
                                                    text={this.state.manager ? user.getFullName(this.state.manager) : ""}
                                                    users={this.props.pmUsers}
                                                    />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Project CO-PM 1:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <AutoUserInput
                                                    bannedUserIDs={this.state.bannedUserIDs}
                                                    disableTab
                                                    forceInitialPopup={false}
                                                    handleFunction={this.handleCoPm1Click}
                                                    handleTextChange={this.handleCoPm1TextChange}
                                                    keepAfterClick
                                                    readOnly={true}
                                                    text={this.state.coManager1 ? user.getFullName(this.state.coManager1) : ""}
                                                    users={this.props.pmUsers}
                                                    />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Project CO-PM 2:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <AutoUserInput
                                                    bannedUserIDs={this.state.bannedUserIDs}
                                                    disableTab
                                                    forceInitialPopup={false}
                                                    handleFunction={this.handleCoPm2Click}
                                                    handleTextChange={this.handleCoPm2TextChange}
                                                    keepAfterClick
                                                    readOnly={true}
                                                    text={this.state.coManager2 ? user.getFullName(this.state.coManager2) : ""}
                                                    users={this.props.pmUsers}
                                                    />
                                            </div>
                                        </div>
                                        <div className={this.state.approverError ? "form-group has-error" : "form-group"}>
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Approver:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <AutoUserInput
                                                    bannedUserIDs={[]}
                                                    enableClear
                                                    forceInitialPopup={false}
                                                    handleFunction={this.handleApproverClick}
                                                    handleTextChange={this.handleApproverTextChange.bind(this, 'approverPicker')}
                                                    keepAfterClick
                                                    noFilter
                                                    ref="approverPicker"
                                                    text={this.state.approver ? user.getFullName(this.state.approver) : ""}
                                                    users={this.state.approvers}
                                                    />
                                            </div>
                                        </div>
                                        <div className={this.state.sponsorError ? "form-group has-error" : "form-group"}>
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Project Sponsor:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <AutoUserInput
                                                    bannedUserIDs={[]}
                                                    forceInitialPopup={false}
                                                    handleFunction={this.handleSponsorClick}
                                                    handleTextChange={this.handleSponsorTextChange}
                                                    readOnly={true}
                                                    keepAfterClick
                                                    noFilter
                                                    ref="sponsorPicker"
                                                    text={this.state.sponsor ? user.getFullName(this.state.sponsor) : ""}
                                                    users={this.props.sponsorUsers}
                                                    />
                                            </div>
                                        </div>
                                        <div className="form-group">
                                            <label className="col-md-3 col-sm-5 control-label">Contractor:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                              <AutoCustomerInput
                                                defaultText={this.state.contractor ? this.state.contractor.name : ""}
                                                handleFunction={this.handleContractorClick}
                                                handleTextChange={this.handleContractorChange}
                                                disabled={true}
                                                keepAfterClick
                                              />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label className="col-md-3 col-sm-5 control-label"> Customer Group:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <CustomerGroupProjectWidget
                                                    addCustomerGroupProject={this.handleAddCustomerGroupProject}
                                                    newlyAssigned={this.state.newlyAssigned}
                                                    project={this.props.project}
                                                    removeExisting={this.handleRemoveExisting}
                                                    removeNewlyAssigned={this.handleRemoveNewlyAssigned}
                                                 />
                                            </div>
                                        </div>

                                        <div className="form-group">
                                            <label className="col-md-3 col-sm-5 control-label">Customer:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <AutoCustomerInput
                                                    defaultText={this.state.customer ? this.state.customer.name : ""}
                                                    handleFunction={this.handleCompanyClick}
                                                    handleTextChange={this.handleCompanyChange}
                                                    keepAfterClick
                                                    disabled={true}
                                                    ref="companyPicker"
                                                    />
                                            </div>
                                            <img src={taggyImage} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Project Name CV:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <input disabled defaultValue={this.state.projectNameCv} onChange={this.handleProjectNameCvChange} type="text" className="form-control" id="project_name_cv"/>
                                            </div>
                                            <img src={taggyImage} />
                                        </div>
                                        <div className="form-group">
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Project Name CV (eng):</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                                <input disabled defaultValue={this.state.projectNameCvEng} onChange={this.handleProjectNameCvEngChange} type="text" className="form-control" id="project_name_cv_eng"/>
                                            </div>
                                            <img src={taggyImage} />
                                        </div>
                                          <div className="form-group">
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Project size:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                              <input disabled defaultValue={projectSizeResolver[this.state.size]}  type="text" className="form-control" id="project_size"/>
                                            </div>
                                          </div>
                                          <div className="form-group">
                                            <label htmlFor="task_name" className="col-md-3 col-sm-5 control-label">Project service types:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7">
                                              <input disabled defaultValue={this.parseServiceTypes(this.state.serviceTypes)} type="text" className="form-control" id="project_service_types"/>
                                            </div>
                                          </div>
                                        <div className="form-group">
                                            <label className="col-md-3 col-sm-5 control-label">Productive:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7" style={{"marginTop": "7px"}}>
                                                <input type="checkbox" disabled={true} onChange={this.handleProductiveChange} checked={this.state.productive}/>
                                            </div>
                                        </div>
										<div className="form-group" hidden={this.props.project.type !== "INTERNAL"}>
                                            <label className="col-md-3 col-sm-5 control-label">Show on Taggy:</label>
                                            <div className="col-lg-6 col-md-7 col-sm-7" style={{"marginTop": "7px"}}>
                                                <input type="checkbox" disabled={!roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO'])} onChange={this.handleShowOnTaggyChange} checked={this.state.showOnTaggy}/>
                                            </div>
                                        </div>
                                    <hr/>
                                    <br/>
                                    {
                                        this.state.setAttributes.map((attribute, attributeKey) => this.renderAttributeField(attribute, attributeKey))
                                    }
                                    <div className="form-footer">
                                        <div className="pull-left">
                                        {
                                            roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO'])
                                            ? <button title="Sync customer list with ERP" type="button" onClick={this.handleSyncCustomers} className="btn btn-default">Sync companies</button>
                                            : null
                                        }
                                        </div>
                                        <div className="text-right">
                                            <button type="button" title="View this project on Taggy" onClick={this.handleLinkToTaggy} className="btn btn-default">
                                                View on Taggy
                                            </button>
                                            &nbsp;&nbsp;
                                        {
                                            (this.props.project.archived || this.state.readOnlyPM) &&
                                                roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO']) ? <button title="Unarchive project" type="button" onClick={this.handleUnarchive} className="btn btn-default">Unarchive</button> : null
                                            
                                        }
                                        {
                                            (roles.userHasAnyOfRoles(JSON.parse(localStorage.getItem('user')), ['PMO']) || (!this.state.readOnlyPM && !this.props.project.archived)) ? 
                                                <span>
                                                <button title="Save changes" type="button" onClick={this.handleSave} style={{backgroundColor : this.props.project.defaultColor}} className="btn btn-default btn-primary">
                                                    Update
                                                </button>
                                            </span>
                                            : null
                                        }
                                        </div>

                                    </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}

EditAttributesWidget.propTypes = {
    approver: PropTypes.string,
    approverName: PropTypes.string,
    approverID: PropTypes.number,
    attributes: PropTypes.array,
    customer: PropTypes.object,
    coPmsAssigned: PropTypes.array,
    currentUser: PropTypes.object,
    defaultColor: PropTypes.string,
    dispatch: PropTypes.func,
    endDate: PropTypes.string,
    inactiveDate: PropTypes.string,
    handleArchiveProject: PropTypes.func,
    handleUnarchiveProject: PropTypes.func,
    handleDeleteProject: PropTypes.func,
    handleSave: PropTypes.func,
    manager: PropTypes.string,
    pmUsers: PropTypes.array,
    project: PropTypes.object,
    projectNames: PropTypes.array,
    refreshProjects: PropTypes.func,
    setActiveTab: PropTypes.func,
    setAttributes: PropTypes.array,
    sponsor: PropTypes.string,
    sponsorName: PropTypes.string,
    sponsorUsers: PropTypes.array,
    startDate: PropTypes.string,
    unarchivedProjects: PropTypes.array,
    contracts: PropTypes.array
};

EditAttributesWidget.defaultProps = {
    attributes: [],
    attributeValues: [],
    coPmsAssigned: [],
    setAttributes: [],
    sponsor: null,
    sponsorName: ""
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
        defaultAttributes: state.attributes.defaultAttributes,
        deletable: state.projects.deletable,
        pmUsers: state.users.pms.users,
        sponsorUsers: state.users.sponsorUsers,
        sameProjects: state.projects.sameProjects,
        unarchivedProjects: state.projects.unarchivedProjects,
        contracts: state.contracts.contracts
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditAttributesWidget);



/** WEBPACK FOOTER **
 ** ./src/app/components/EditAttributesWidget.js
 **/